
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/x/api/charts/area-plot",
      function () {
        return require("private-next-pages/x/api/charts/area-plot.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/x/api/charts/area-plot"])
      });
    }
  